import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ShareNewListingModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ShareNewListingModal" */
      './ShareNewListingModal.dynamic'
    ),
  loading: LoadingModal,
});
